import { ModeIds } from "@chesshotel/constants";
import React from "react";
import styles from "./Profile.module.css";
import { BulletIcon } from "../../icons/BulletIcon";
import { FaBolt } from "react-icons/fa";
import { FaDragon } from "react-icons/fa";
import { FaDiceSix } from "react-icons/fa";
import { FaIdBadge } from "react-icons/fa";
import { FaChessBoard } from "react-icons/fa";
import { FaAward } from "react-icons/fa";

import useTranslation from "next-translate/useTranslation";
import {
  MODE_ID_PRACTICE_CHESS,
  MODE_ID_PRACTICE_CHESS960,
  MEMBERSHIP_PAGE,
  MEDALS_PAGE,
} from "@chesshotel/constants";
import { useRouter } from "next/router";
import { useLeagues } from "../../ducks/leagues";
import { FaPaperPlane } from "react-icons/fa";

const ProfileMenu = ({}) => {
  const { t } = useTranslation("common");
  const { t: profileT } = useTranslation("auth");

  const router = useRouter();
  const { modeId } = router.query;

  const activeModeId = Number(modeId) || MEMBERSHIP_PAGE;

  const { hasMedals, hasLastSeason } = useLeagues();

  const baseUrl = "/profile/";

  const itemStyles = {
    [ModeIds.BULLET]: styles.sidebarItem,
    [ModeIds.BLITZ]: styles.sidebarItem,
    [ModeIds.RAPID]: styles.sidebarItem,
    [ModeIds.CHESS960]: styles.sidebarItem,
    [ModeIds.DAILY]: styles.sidebarItem,

    [MODE_ID_PRACTICE_CHESS]: styles.sidebarItem,
    [MODE_ID_PRACTICE_CHESS960]: styles.sidebarItem,
    [MEMBERSHIP_PAGE]: styles.sidebarItem,
    [MEDALS_PAGE]: styles.sidebarItem,
  };
  itemStyles[activeModeId] += " " + styles.active;

  return (
    <div className={styles.sidebar}>
      <div className={styles.menu}>
        <div
          className={itemStyles[MEMBERSHIP_PAGE]}
          onClick={() => router.replace(`${baseUrl}?modeId=${MEMBERSHIP_PAGE}`)}
        >
          <div className={styles.icon}>
            <FaIdBadge />
          </div>
          <div className={styles.text}>{profileT("Membership")}</div>
        </div>
        {(hasMedals || hasLastSeason) && (
          <div
            className={itemStyles[MEDALS_PAGE]}
            onClick={() => router.replace(`${baseUrl}?modeId=${MEDALS_PAGE}`)}
          >
            <div className={styles.icon}>
              <FaAward />
            </div>
            <div className={styles.text}>{t("Medals")}</div>
          </div>
        )}
        <div className={styles.submenuTitle}> {t("Leagues").toUpperCase()}</div>
        <div className={styles.submenu}>
          <div
            className={itemStyles[ModeIds.BULLET]}
            onClick={() =>
              router.replace(`${baseUrl}?modeId=${ModeIds.BULLET}`)
            }
          >
            <div className={styles.icon}>
              <BulletIcon />
            </div>
            <div className={styles.text}>Bullet</div>
          </div>
          <div
            className={itemStyles[ModeIds.BLITZ]}
            onClick={() => router.replace(`${baseUrl}?modeId=${ModeIds.BLITZ}`)}
          >
            <div className={styles.icon}>
              <FaBolt />
            </div>
            <div className={styles.text}>Blitz</div>
          </div>
          <div
            className={itemStyles[ModeIds.RAPID]}
            onClick={() => router.replace(`${baseUrl}?modeId=${ModeIds.RAPID}`)}
          >
            <div className={styles.icon}>
              <FaDragon />
            </div>
            <div className={styles.text}>Rapid</div>
          </div>
          <div
            className={itemStyles[ModeIds.CHESS960]}
            onClick={() =>
              router.replace(`${baseUrl}?modeId=${ModeIds.CHESS960}`)
            }
          >
            <div className={styles.icon}>
              <FaDiceSix />
            </div>
            <div className={styles.text}>{t("Chess960")}</div>
          </div>
          <div
            className={itemStyles[ModeIds.DAILY]}
            onClick={() => router.replace(`${baseUrl}?modeId=${ModeIds.DAILY}`)}
          >
            <div className={styles.icon}>
              <FaPaperPlane />
            </div>
            <div className={styles.text}>{t("Daily")}</div>
          </div>
        </div>
        <div className={styles.submenuTitle}>{t("Practice").toUpperCase()}</div>
        <div className={styles.submenu}>
          <div
            className={itemStyles[MODE_ID_PRACTICE_CHESS]}
            onClick={() =>
              router.replace(`${baseUrl}?modeId=${MODE_ID_PRACTICE_CHESS}`)
            }
          >
            <div className={styles.icon}>
              <FaChessBoard />
            </div>
            <div className={styles.text}>{profileT("Chess")}</div>
          </div>
          <div
            className={itemStyles[MODE_ID_PRACTICE_CHESS960]}
            onClick={() =>
              router.replace(`${baseUrl}?modeId=${MODE_ID_PRACTICE_CHESS960}`)
            }
          >
            <div className={styles.icon}>
              <FaDiceSix />
            </div>
            <div className={styles.text}>{t("Chess960")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileMenu;
